<!-- orden-medica-modal.component.html -->

<div class="modal-wrap">
    <button class="btn-close" (click)="cerrar()">
        <i class="fas fa-times-circle"></i>
    </button>

    <h2>Orden de Consulta</h2>
    <p class="sub">Genere su orden para atención.</p>

    <p class="sub" style="font-size: 13px; margin-bottom: 12px">
        Elegí quién va a usar esta orden médica
    </p>

    <!-- =========================
     Selector de Beneficiario (Titular + Familiares)
     ========================= -->
    <div
        class="selector-beneficiario"
        *ngIf="familiares?.length > 0 && !generada && puedeGenerar"
    >
        <!-- TITULAR (resaltado) -->
        <div class="selector-section">
            <div class="section-title">Titular</div>

            <label
                class="benef-card titular"
                [class.selected]="usuarioSeleccionado?._id === titularItem._id"
            >
                <input
                    type="radio"
                    name="beneficiario"
                    [checked]="usuarioSeleccionado?._id === titularItem._id"
                    (change)="usuarioSeleccionado = titularItem; validar()"
                />

                <div class="benef-info">
                    <div class="benef-name">
                        {{ titularItem.apellido }}, {{ titularItem.nombre }}
                    </div>
                    <div class="benef-sub">
                        <span class="badge">TITULAR</span>
                        <span class="sep">·</span>
                        DNI {{ titularItem.identificacion }}
                    </div>
                </div>
            </label>
        </div>

        <!-- FAMILIARES A CARGO -->
        <div class="selector-section" *ngIf="familiares.length > 1">
            <div class="section-title">Familiares a cargo</div>

            <div class="benef-list">
                <label
                    class="benef-card"
                    *ngFor="let f of familiaresACargo"
                    [class.selected]="usuarioSeleccionado?._id === f._id"
                >
                    <input
                        type="radio"
                        name="beneficiario"
                        [checked]="usuarioSeleccionado?._id === f._id"
                        (change)="usuarioSeleccionado = f; validar()"
                    />

                    <div class="benef-info">
                        <div class="benef-name">
                            {{ f.apellido }}, {{ f.nombre }}
                        </div>

                        <div class="benef-sub">
                            <span class="badge soft">{{ f.parentesco }}</span>
                            <span class="sep">·</span>
                            DNI {{ f.identificacion }}
                        </div>
                    </div>
                </label>
            </div>
        </div>
    </div>

    <!-- =========================
       Estado de validación
       ========================= -->
    <div class="alerts-wrap" *ngIf="validando">
        <div class="alert info">
            <i class="fas fa-spinner fa-spin"></i>
            Validando disponibilidad para generar la orden...
        </div>
    </div>

    <div
        class="alerts-wrap"
        *ngIf="!validando && !puedeGenerar && mensajeValidacion"
    >
        <div class="alert warn">
            <i class="fas fa-info-circle"></i>
            {{ mensajeValidacion }}
        </div>
    </div>

    <!-- =========================
       Acciones principales
       ========================= -->
    <div class="main-actions" *ngIf="!generada && puedeGenerar">
        <button
            class="btn btn-primary"
            (click)="confirmarYGenerar()"
            [disabled]="!puedeGenerar || validando || generando"
        >
            {{ generando ? "GENERANDO..." : "GENERAR" }}
        </button>
    </div>

    <!-- =========================
       Acciones secundarias
       (solo si ya generó)
       ========================= -->
    <div class="secondary-actions" *ngIf="generada">
        <div class="share-wrap">
            <button
                class="icon-btn"
                (click)="compartirWhatsApp()"
                title="Compartir por WhatsApp"
                aria-label="Compartir la orden en WhatsApp"
            >
                <i class="fab fa-whatsapp"></i>
            </button>
            <div class="tiny-hint">Compartir por WhatsApp</div>
        </div>

        <div class="download-wrap">
            <button
                class="icon-btn"
                (click)="descargarPDF()"
                title="Descargar PDF"
                aria-label="Descargar orden de consulta en PDF"
            >
                <i class="fas fa-download"></i>
            </button>
            <div class="tiny-hint">Descargar la orden en PDF</div>
        </div>
    </div>

    <!-- =========================
       Vista previa
       ========================= -->
    <div class="preview" *ngIf="generada && mostrandoPreview">
        <div #ordenHtmlRef class="orden-a4">
            <div class="header text-center">
                <img
                    src="assets/img/logo-femesfe.png"
                    alt="Federación Médica"
                    class="logo-header"
                />
                <h2><strong>ORDEN DE CONSULTA</strong></h2>
                <p>
                    <em>Federación Médica<br />de la Provincia de Santa Fe</em>
                </p>
                <p>
                    Rioja 1625 - Tel. 341 837 9236 (8 a 14hs.)<br />
                    WhatsApp: 341 6960198<br />
                    Email: rasrosario@femesfe.org<br />
                    2000 Rosario - Santa Fe
                </p>
            </div>

            <!-- Meta -->
            <div class="meta">
                <div>
                    <strong>N° de Orden:</strong> {{ modeloOrden.nroOrden }}
                </div>
                <div>
                    <strong>Fecha:</strong>
                    {{ fecha | date: "dd/MM/yyyy HH:mm" }}
                </div>
            </div>

            <div class="prepago">
                <strong>PREPAGO:</strong> OSOETSYLRA - SIGNO MÉDICO
            </div>

            <hr />

            <!-- Datos del Afiliado -->
            <div class="datos">
                <div class="row">
                    <div class="label">Apellido y Nombre</div>
                    <div class="value">{{ modeloOrden.apellidoNombre }}</div>
                </div>
                <div class="row">
                    <div class="label">N° Beneficiario</div>
                    <div class="value">{{ modeloOrden.identificacion }}</div>
                </div>
                <div class="row">
                    <div class="label">Edad</div>
                    <div class="value">{{ modeloOrden.edad }}</div>
                </div>
                <div class="row">
                    <div class="label">Plan</div>
                    <div class="value">{{ modeloOrden.plan }}</div>
                </div>
                <div class="row">
                    <div class="label">Tipo</div>
                    <div class="value">{{ modeloOrden.tipo }}</div>
                </div>
                <div class="row">
                    <div class="label">Sede</div>
                    <div class="value">{{ modeloOrden.sede }}</div>
                </div>
            </div>

            <div class="nota">
                <p>
                    Esta orden habilita la atención, según normativa vigente.
                    Presentar junto con la credencial y DNI del titular. Válida
                    para un único uso.
                </p>
            </div>

            <div class="footer">
                <div>signomedico.org</div>
            </div>
        </div>
    </div>
</div>
